import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, hideElement, displayElement, addClass, removeClass } from '@fretadao/f-js-dom';

application.register(
  'batch-search',
  class extends Controller {
    connect() {
      this.changeDestination();
      hideElement(find('#search_schedule_arrival_input'));
      hideElement(find('#search_schedule_departure_input'));
      hideElement(find('#search_shifts_input'));
    }

    changeDestination() {
      const agreement = find('#agreement');
      let canChangeName = false;

      if(agreement.value) {
        this.changeRequiredField(find('#select-address'), find('#search_destination_address'));
        this.showAndHideFields(find('.select-address'), find('.address'));
        this.changeFieldName(find('#select-address'), find('#search_destination_address'));

        canChangeName = true;
      } else {
        this.changeRequiredField(find('#search_destination_address'), find('#select-address'));
        this.showAndHideFields(find('.address'), find('.select-address'));

        if (canChangeName) {
          this.changeFieldName(find('#search_destination_address'), find('#select-address'));
          canChangeName = false;
        }
      }
    }

    showAndHideFields(elementToShow, elementTohide) {
      displayElement(elementToShow);
      hideElement(elementTohide);
    }

    changeRequiredField(elementToMakeRequired, elementToRemoveRequired) {
      elementToMakeRequired.required = true;
      elementToRemoveRequired.required = false;
    }

    changeFieldName(firstElementToChange, secondElementToChange) {
      const aux = firstElementToChange.name;

      firstElementToChange.name = secondElementToChange.name;
      secondElementToChange.name = aux;
    }

    selectFilter() {
      const filter = find('input[name="search[filters]"]:checked').value;
      const searchScheduleArrivelInput = find('#search_schedule_arrival_input input');
      const searchscheduleDepartureInput = find('#search_schedule_departure_input input');
      const scheduleInputs = [searchScheduleArrivelInput, searchscheduleDepartureInput]
      const searchShiftSelect = find('#search_shifts_input select');

      if (filter === 'schedule') {
        scheduleInputs.forEach(this.#showField.bind(this));
        scheduleInputs.forEach(this.#requireField.bind(this));

        this.#hideField(searchShiftSelect);

        this.#allowEmptyField(searchShiftSelect);

        this.#clearSelectField(searchShiftSelect);
      } else if(filter === 'shift') {
        this.#showField(searchShiftSelect);
        
        this.#requireField(searchShiftSelect);
        
        scheduleInputs.forEach(this.#hideField.bind(this));

        scheduleInputs.forEach(this.#allowEmptyField.bind(this));

        scheduleInputs.forEach(this.#clearField.bind(this));
      }
    }

    #requireField(field) {
      field.setAttribute('required', true);
      const fieldContainer = field.closest('li');
      const fieldLabel = find('label', fieldContainer);
      const abbrIsPresent = find('abbr', fieldLabel);

      const requiredAbbrNode = document.createElement('abbr');
      requiredAbbrNode.append('*');

      addClass(fieldContainer, 'required');
      if (!abbrIsPresent) fieldLabel.append(requiredAbbrNode);
    }

    #allowEmptyField(field) {
      field.removeAttribute('required');
      const fieldContainer = field.closest('li');
      const fieldLabel = find('label', fieldContainer);
      const requiredAbbrNode = find('abbr', fieldLabel);

      removeClass(fieldContainer, 'required');
      if (requiredAbbrNode) requiredAbbrNode.remove();
    }

    #hideField(field) {
      const fieldContainer = field.closest('li');

      hideElement(fieldContainer);
    }

    #showField(field) {
      const fieldContainer = field.closest('li');

      displayElement(fieldContainer);
    }

    #clearField(field) {
      field.value = '';
    }

    #clearSelectField(field) {
      Array.from(field.options).forEach(option => option.selected = false);
      field.dispatchEvent(new Event('change'));
    }
  }
)
